import { render, staticRenderFns } from "./BroadcastModal.vue?vue&type=template&id=02aa2b44&scoped=true&"
import script from "./BroadcastModal.vue?vue&type=script&lang=ts&"
export * from "./BroadcastModal.vue?vue&type=script&lang=ts&"
import style0 from "./BroadcastModal.vue?vue&type=style&index=0&id=02aa2b44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02aa2b44",
  null
  
)

export default component.exports